import { jsx, Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { useConfig } from "../../contexts/config-context.js";
import { getDateFormatParts, isSupportedDatePart } from "../../utils/date-format-parts.js";
import { getDateComponentWUT } from "./date-components-wut.js";
import { deserializeDate } from "./helpers.js";
function DatePickerWUT({ value, ...rest }) {
  const { regionalFormat } = useConfig();
  const dateFormat = getDateFormatParts(regionalFormat).filter(isSupportedDatePart);
  const dateFormatPartsStr = dateFormat.join(",");
  const DateComponents = useMemo(
    () => dateFormatPartsStr.split(",").map(
      (part) => (
        // Can be removed after migration
        getDateComponentWUT(part.toUpperCase())
      )
    ),
    [dateFormatPartsStr]
  );
  const values = useMemo(() => deserializeDate(value), [value]);
  return /* @__PURE__ */ jsx(Fragment, { children: DateComponents.map((DateComponent, index) => /* @__PURE__ */ jsx(DateComponent, { values, ...rest }, index)) });
}
export {
  DatePickerWUT
};
//# sourceMappingURL=date-picker-wut.js.map
